const prefix = '@partner-details/';

export const CHANGE_PARTNER = `${prefix}CHANGE_PARTNER`;

// activities
export const GET_ACTIVITY = `${prefix}GET_ACTIVITY`;

// files
export const GET_FILES = `${prefix}GET_FILES`;

// PartnerInfo
export const GET_PARTNER_INFO = `${prefix}GET_PARTNER_INFO`;

export const CLEAR_STORE = `${prefix}CLEAR_STORE`;

export const CONVERSATIONS_READ = `${prefix}CONVERSATIONS_READ`;

export const UPDATE_PROPS = `${prefix}UPDATE_PROPS`;
export const RESET_TEMPLATE_SELECTION = `${prefix}RESET_TEMPLATE_SELECTION`;
export const RESET_LOCATION_SELECTION = `${prefix}RESET_LOCATION_SELECTION`;
export const POPULATE_REDUCER = `${prefix}POPULATE_REDUCER`;

export const UPDATE_PARTNER_DETAILS = `${prefix}UPDATE_PARTNER_DETAILS`;

export const UNASSOC_A_MESSAGE = `${prefix}UNASSOC_A_MESSAGE`;

export const OPEN_MAPPING_DIALOG = `${prefix}OPEN_MAPPING_DIALOG`;
export const CLOSE_MAPPING_DIALOG = `${prefix}CLOSE_MAPPING_DIALOG`;
export const UPDATE_MAPPING_DIALOG_FIELD = `${prefix}UPDATE_MAPPING_DIALOG_FIELD`;
export const SET_MAPPING_DIALOG_ERROR = `${prefix}SET_MAPPING_DIALOG_ERROR`;
export const CLEAR_MAPPING_DIALOG_ERROR = `${prefix}CLEAR_MAPPING_DIALOG_ERROR`;
export const SET_MAPPING_DIALOG_SAVE_PENDING = `${prefix}SET_MAPPING_DIALOG_SAVE_PENDING`;
export const LOAD_MAPPING_APP_KEYS = `${prefix}LOAD_MAPPING_APP_KEYS`;
export const LOAD_MAPPING_LOOKUP_PARTNERS = `${prefix}LOAD_MAPPING_LOOKUP_PARTNERS`;
export const SAVE_MAPPING_DIALOG = `${prefix}SAVE_MAPPING_DIALOG`;
